import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Actions} from 'jumpstate'
import {Grid, Col, Row, Image, Button} from 'react-bootstrap'
import {Helmet} from 'react-helmet'
import {latinToPersian} from '@thg303/react-persian'
import {IahoAddHorse} from '../Common/ReactIcons/icons'
import HorseLoading from '../Common/HorseLoading/HorseLoading'
import NotFound from '../Common/NotFound/NotFound'
import HorseBox from '../Common/HorseBox/HorseBox'

import './Layout/OwnerScreen.css'

const defaultAvatar = `${window.location.protocol}//${window.location.host}/default_avatar.png`

class OwnerScreen extends Component {
  constructor (props) {
    super(props)

    this.state = {
      term: props.params.key,
      page: 1,
      data: [],
      showMoreButton: false,
      hasNextPage: false,
      isLoading: true,
      showNotFound: false,
      owner: null,
      nextPageData: []
    }

    this.nextPage = this.nextPage.bind(this)
    this.hideShowMoreAndLoadNextPage = this.hideShowMoreAndLoadNextPage.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
    this.calculateHasNextPage = this.calculateHasNextPage.bind(this)
    this.loadOwner = this.loadOwner.bind(this)
    this.isNextPageData = this.isNextPageData.bind(this)
  }

  isNextPageData (data) {
    return this.state.page !== data
  }

  loadOwner (key) {
    Actions.loadOwnerHorseAndDetails({term: key, page: 1}).catch((e) => {
      if (e.response.status === 404) {
        this.setState({isLoading: false, showNotFound: true})
      }
    })
  }

  calculateHasNextPage (currentPage) {
    Actions.loadOwnerHorses({term: this.state.term, page: parseInt(currentPage, 10) + 1}).then((res) => {
      this.setState({hasNextPage: true, nextPageData: res.data})
    }).catch((e) => this.setState({hasNextPage: false, nextPageData: []}))
  }

  handleScroll () {
    const windowHeight = 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight
    const body = document.body
    const html = document.documentElement
    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
    const windowBottom = windowHeight + window.pageYOffset
    if (windowBottom >= docHeight) {
      this.nextPage()
    }
  }

  componentWillMount () {
    if (this.props.owner.horses.length > 0) {
      if (this.props.params.key === this.props.owner.key) {
        return this.setState({
          isLoading: false,
          data: this.props.owner.horses,
          owner: this.props.owner.details,
          term: this.props.params.key,
          page: 1
        }, () => this.calculateHasNextPage(this.state.page))
      }
    }
    if (window.__BROWSER_ENV__) {
      this.loadOwner(this.props.params.key)
    }
  }

  componentWillReceiveProps (nextProps) {
    const newKey = nextProps.params.key
    if (!!nextProps.owner.details && !!nextProps.owner.horses.length) {
      if (newKey !== this.props.owner.key) {
        return undefined
      }

      if (this.props.owner.horses.length > 0 && (nextProps.owner.horses[0].id !== this.props.owner.horses[0].id || this.isNextPageData(nextProps.owner.horsePage))) {
        return undefined
      }
      this.setState({
        owner: nextProps.owner.details,
        data: (this.state.data === [] || newKey !== this.props.owner.key) ? nextProps.owner.horses : [...this.state.data, ...nextProps.owner.horses],
        term: newKey,
        isLoading: false
      }, () => this.calculateHasNextPage(this.state.page))
    }
    if (this.state.term !== newKey) {
      this.setState({
        term: newKey,
        page: 1
      }, () => this.loadOwner(newKey))
    }
  }

  componentDidMount () {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.handleScroll)
  }

  nextPage () {
    if (this.state.showMoreButton) {
      return undefined
    }
    if (this.state.hasNextPage) {
      let nextPage = this.state.page + 1
      this.setState({
        data: [...this.state.data, ...this.state.nextPageData],
        page: nextPage,
        showMoreButton: (nextPage % 3) === 0
      }, () => this.calculateHasNextPage(this.state.page))
    }
  }

  hideShowMoreAndLoadNextPage () {
    this.setState({showMoreButton: false})
    this.nextPage()
  }

  render () {
    const { isLoading, showMoreButton, showNotFound, owner, data } = this.state
    return (
      <div className="SearchResult" id="owner-screen">
        {isLoading ? <HorseLoading />
          : showNotFound ? <NotFound route={this.props.location} />
            : <Grid>
              <Helmet>
                <title>Iaho</title>
                <meta name="description" content="ایاهو؛ موتور جستجوی اسب اصیل" />
                <meta property="og:title" content={owner.name} />
                <meta property="og:locale" content="fa_IR" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="ایاهو | موتور جستجوی اسب اصیل" />
                <meta property="og:description" content={`مالک ${latinToPersian(owner.horses_count)} رأس اسب، از جمله ${data.map(item => item.name).join('، ')}`} />
                <meta property="og:image" content={`${owner.avatar ? owner.avatar : defaultAvatar}`} />
                <meta property="og:url" content="https://iaho.ir/" />
                <meta property="twitter:description" content={`مالک ${latinToPersian(owner.horses_count)} رأس اسب، از جمله ${data.map(item => item.name).join('، ')}`} />
                <meta property="twitter:card" content="ایاهو؛ موتور جستجوی اسب اصیل" />
                <meta name="twitter:image:alt" content={owner.name} />
              </Helmet>
              <Row className="cover" />
              <Row className="details">
                <Col className="image" xs={3}><Image src={owner.avatar ? owner.avatar : defaultAvatar} alt={owner.name} /></Col>
                <Col className="name" xs={9}>
                  <h3>{owner.name}</h3>
                  <p><IahoAddHorse /> <span>{owner.horses_count}</span></p>
                </Col>
              </Row>
              <Row>
                {data.map((item, index) => (
                  <HorseBox key={index} horse={item} />
                  ))}
              </Row>
              <Row className="MoreButton">
                {showMoreButton && <Button bsStyle="info" onClick={this.hideShowMoreAndLoadNextPage} block>نمایش بیشتر...</Button>}
              </Row>
            </Grid>
        }
      </div>
    )
  }
}

OwnerScreen.fetchData = ({params}) => {
  return Actions.loadOwnerHorseAndDetails({term: params.key})
}

function mapStateToProps (state) {
  return {
    owner: state.owner
  }
}

export default connect(mapStateToProps)(OwnerScreen)



// WEBPACK FOOTER //
// ./src/components/Owner/OwnerScreen.js